module.exports = __webpack_public_path__ + "static/media/kid_avatar_10.7a92a0d8.png";